var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoost(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 8.27a.52.52 0 00-.5-.27H9.22L12 .68a.52.52 0 00-.06-.47.51.51 0 00-.44-.21h-7a.5.5 0 00-.5.33l-4 11a.51.51 0 00.06.46.51.51 0 00.44.21h5.41L4 23.42a.49.49 0 00.3.54.41.41 0 00.19 0 .48.48 0 00.4-.2l11-15a.51.51 0 000-.52",
    fill: "#fda926",
    fillRule: "evenodd"
  })));
}
SvgBoost.displayName = 'Boost';
export default SvgBoost;